'use strict';

export default class ProducerCtrl {
  static get UID() {
    return 'producerCtrl';
  }

  constructor($state, $stateParams, producerFac) {
    Object.assign(this, {$state, $stateParams, producerFac } );

    this.producer = {};
    this.currentPage = parseInt($stateParams.pageNum, 10) || 1;

    producerFac.getProducer($stateParams.producerId)
      .then((response) => {
        console.log('-- reponse', response.data);
        this.producer = response.data.data;
      });
  }

  pagination(pageNumber) {
    let pn = parseInt(pageNumber, 10) || 1;
    this.$state.go('producer', {pageNum, pn});
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/features/producer/producerCtrl.js